import { DeclarationTypeResponse } from 'generated/index';
import { mutations } from 'RestAPIs/rapini';
import dayjs from 'dayjs';

export const useSaveDeclarationType = (props: { onSuccess: () => void }) => {
  const { mutate: createDeclarationType, isLoading: isCreateLoading } =
    mutations.useCreateDeclarationType();
  const { mutate: updateDeclarationType, isLoading: isUpdateLoading } =
    mutations.useUpdateDeclarationType();

  const mutate = (data: DeclarationTypeResponse) => {
    const payload = {
      name: data.name!,
      isDefault: data.isDefault ?? false,
      validFrom: dayjs(data.validFrom).startOf('day').toISOString(),
      validTo: dayjs(data.validTo).startOf('day').toISOString()
    };

    if (!data.id) {
      createDeclarationType(payload, {
        onSuccess: props.onSuccess
      });
    } else {
      updateDeclarationType(
        {
          id: data.id,
          ...payload
        },
        {
          onSuccess: props.onSuccess
        }
      );
    }
  };

  return {
    mutate,
    isLoading: isCreateLoading || isUpdateLoading
  };
};
